import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { d: "M2 2v20h20V2H2zm14.994 14.564h-3.416l-3.221-4.741v4.741H7.004v-9.15h3.416l3.223 4.726V7.414h3.351v9.15z" }));
export default createSvgIcon(iconPath, "Naver");
//# sourceMappingURL=NaverIcon.js.map